// extracted by mini-css-extract-plugin
module.exports = {"title":"EditPanelMainSection_title__1Ccb8","noMargins":"EditPanelMainSection_noMargins__2rpsp"};